module.exports = __webpack_public_path__ + "static/media/question.189dea5d.png";